import { IconButton, Stack, Badge, Popover, Box, InputBase } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import MessageError from '../messages/messageError';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import api from "../services/api";
import LoadingShort from "../load/loadingShort";

export default function SolicitacaoNomeEntradaFilter({ setEstabelecimentos, status, placeholder }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
    setMessageError('');
  };

  // const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [openLoad, setOpenLoad] = useState(false);
  const [messageError, setMessageError] = useState('');

  const searchEstabelecimento = async (e) => {
    e.preventDefault();
    setOpenLoad(true);

    try {
      const response = await api.post(`/estabelecimento/search`, {
        search,
        status: status,
      });

      setEstabelecimentos(response.data.estabelecimentos);
    } catch (error) {
      setEstabelecimentos("");
    } finally {
      setOpenLoad(false);
    }
  };


  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!search}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>

          {messageError && <MessageError message={messageError} />}

          <form onSubmit={searchEstabelecimento} style={{ display: 'flex', }}>
            <InputBase
              required
              autoFocus
              style={{ maxWidth: 560, marginLeft: 'auto', marginRight: 'auto' }}
              sx={{ ml: 1, flex: 1 }}
              placeholder={placeholder}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
            <IconButton type="submiy" aria-label="search">
              {openLoad ? <LoadingShort /> : <PersonSearchIcon />}
            </IconButton>
          </form>

          {/* <Box mt={2} display="flex" justifyContent="flex-end">
            <Button size="small" onClick={handleClear}>
              Limpar
            </Button>
          </Box> */}
        </Box>
      </Popover>
    </Stack>
  );
};


